import React, { Component } from 'react';
import MainContainer from '../../../components/MainContainer';
import { observer, inject } from 'mobx-react';
import './dashboard.css';

@inject("authStore")
@observer
class AdminDashboardPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <MainContainer title="Dashboard">
            </MainContainer>
        )
    }
}

export default AdminDashboardPage;